const API_URL = {
  dev: {
    AUTH_API: "/testAuthapi",
    YSWX_API: "/testapi",
    tiKuUrl: "/testTikuapi",
    OFFICIAL_API: "http://officialapi-test.lingjiang.com",
    PAY_URL: "http://official-test.lingjiang.com/payment/"
  },
  test: {
    AUTH_API: "//authapi-test.lingjiang.com",
    YSWX_API: "//mis1-test.lingjiang.com",
    tiKuUrl: "//examapi-test.lingjiang.com",
    OFFICIAL_API: "//officialapi-test.lingjiang.com",
    PAY_URL: "//official-test.lingjiang.com/payment/"
  },
  prod: {
    AUTH_API: "//authapi.lingjiang.com",
    YSWX_API: "//mis1.lingjiang.com",
    tiKuUrl: "//examapi.lingjiang.com",
    OFFICIAL_API: "//officialapi.lingjiang.com",
    PAY_URL: "https://www.lingjiang.com/payment/"
  }
};
const _ENV =
  location.origin.includes("localhost") || location.origin.includes("172.")
    ? "dev"
    : location.origin.includes("test")
    ? "test"
    : "prod";

var AUTH_API = API_URL[_ENV]["AUTH_API"];
var YSWX_API = API_URL[_ENV]["YSWX_API"];
var OFFICIAL_API = API_URL[_ENV]["OFFICIAL_API"];
var PAY_URL = API_URL[_ENV]["PAY_URL"];
var tiKuUrl = API_URL[_ENV]["tiKuUrl"];

import axios from "axios";

// 获取数据 获取用户信息
export async function getUserInfo(token) {
  const res = await axios.get(OFFICIAL_API + "/v1/users/me", {
    headers: {
      Authorization: "Bearer " + token
    }
  });
  return res;
}
// 获取手机验证码
export async function getChecknum(params) {
  const res = await axios.post(AUTH_API + `/v1/sms`, params);
  return res;
}
// 验证码登录
export async function phoneCodeLogin(params) {
  const res = await axios.post(AUTH_API + `/v1/student/sign-in/phone`, params);
  return res;
}
// 上报推广方案
export async function uploadRegistrEvent(params) {
  const res = await axios.post(YSWX_API + `/api/registration/save`, params);
  return res;
}
// 登录统计
export async function loginRecord(application, token) {
  var uaParser = new UAParser();
  let r = uaParser.getResult();
  const params = {
    equipmentType: 2, // 设备类型（1：手机 2：PC 3：平板）
    application: application, // 1、云课堂App 2、官网 3、报考小程序 4、会计知道小程序 5、评审圈App 6、活动页
    loginChannel: 1, // 1、短信登录 2、账号密码登录 3、微信登录
    deviceId: r.browser.name + " " + r.browser.major
  };
  const res = await axios.post(
    YSWX_API + `/api/v2/students/loginrecord`,
    params,
    {
      headers: {
        Authorization: "Bearer " + token
      }
    }
  );
  return res;
}
// 获取模考场次列表
export async function getScenesList(code, token) {
  const res = await axios.get(
    tiKuUrl + `/api/scenes/${code}/config`,
    token
      ? {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      : {}
  );
  return res;
}

// 模考预约
export async function modeltestAppointment(sceneId, token) {
  const res = await axios.post(
    tiKuUrl + `/api/scenes/${sceneId}/appointment`,
    {},
    {
      headers: {
        Authorization: "Bearer " + token
      }
    }
  );
  return res;
}

// 再次预约
export async function againAppointment(sceneId, token) {
  const res = await axios.delete(tiKuUrl + `/api/scenes/${sceneId}/cancel`, {
    headers: { Authorization: "Bearer " + token }
  });
  return res;
}



// WEBPACK FOOTER //
// ./src/api/api.js